/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LegalInputs */

const en_nav_legal = /** @type {(inputs: Nav_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const es_nav_legal = /** @type {(inputs: Nav_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Nav_LegalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_legal = /** @type {((inputs?: Nav_LegalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LegalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_legal(inputs)
	return es_nav_legal(inputs)
});